//*Libraries imports
import { z } from "zod";

//*Schemas imports
import { formSchema } from "./form";
import { tutorialSchema } from "./tutorial";
import { templateOutputDTOSchema, techinicalOutputDTOSchema } from "./document";

export const activityTypeSchema = z.enum([
  "form",
  "external",
  "document_generation",
]);

export type ActivityType = z.infer<typeof activityTypeSchema>;

export const activitySchema = z.object({
  _id: z.string().optional(),
  name: z.string(),
  description: z.string(),
  image: z.string().optional(),
  hours: z.number().optional(),
  days: z.number().optional(),
  order: z.number(),
  type: activityTypeSchema,
  form: formSchema.optional(),
  prerequisites: z.array(z.string()).optional(),
  duration: z.number(),
  typeRefId: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  tutorial: tutorialSchema,
  documents: z.array(z.string()).optional(),
  templates: z.array(z.union([z.string(), templateOutputDTOSchema])).optional(),
  techinicals: z
    .array(z.union([z.string(), techinicalOutputDTOSchema]))
    .optional(),
});
